export enum CancelBy {
  AGENCY = 'agency',
  ASSET = 'asset',
  LEAD = 'lead',
  RESCHEDULING = 'rescheduling',
  MOVING = 'moving',
}
